import { render, staticRenderFns } from "./RefreshProducts.vue?vue&type=template&id=bfd547c4&scoped=true&"
import script from "./RefreshProducts.vue?vue&type=script&lang=js&"
export * from "./RefreshProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd547c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfd547c4')) {
      api.createRecord('bfd547c4', component.options)
    } else {
      api.reload('bfd547c4', component.options)
    }
    module.hot.accept("./RefreshProducts.vue?vue&type=template&id=bfd547c4&scoped=true&", function () {
      api.rerender('bfd547c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Products/RefreshProducts.vue"
export default component.exports